import script from "./AddToHomeScreen.vue?vue&type=script&lang=tsx"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=tsx"

import "./AddToHomeScreen.vue?vue&type=style&index=0&id=5c43e7e1&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c43e7e1"]])

export default __exports__